import { pluck, isEmpty } from 'ramda';
import { types, prefix } from '../actions/options';
import { types as citiesTypes } from '../reducers/cities';
import { types as crimeTypes } from '../reducers/crimes';
import { Sort, VisType } from '../constants';
import optionsBase, { initialState as baseInitialState } from './optionsBase';
import { fulfilled } from '../utils/helpers';

export const initialState = {
  ...baseInitialState,
  sortColumn: Sort.NAME,
  sortReversed: false,
  sortPage: 0,
  compChartType: VisType.DIFFERENCE,
  // XXX: null means "no specific user selection" so it works like all selected
  selectedCitiesIds: [],
  selectedCensusTractsIds: [],
};

export const baseReducer = optionsBase(prefix);

export default (state = initialState, action) => {
  const interState = baseReducer(state, action);

  const { type, payload } = action;
  switch (type) {
    case fulfilled(citiesTypes.FETCH_CITIES):
      return {
        ...interState,
        selectedCitiesIds: isEmpty(state.selectedCitiesIds)
          ? pluck('id', payload)
          : state.selectedCitiesIds,
      };

    case fulfilled(crimeTypes.FETCH_CENSUS_CRIMES):
      return {
        ...interState,
        selectedCensusTractsIds: Object.keys(payload),
      };

    case types.SELECT_CITIES:
      return {
        ...interState,
        selectedCitiesIds: payload.selected,
      };

    case types.SELECT_CENSUS_TRACTS:
      return {
        ...interState,
        selectedCensusTractsIds: payload.selected,
      };

    case types.BATCH_SET_OPTIONS:
      return {
        ...interState,
        ...payload,
      };

    case types.SET_SORTING:
      return {
        ...interState,
        sortColumn: payload.sortColumn,
        sortReversed: payload.sortReversed,
      };

    case types.SET_SORT_PAGE:
      return {
        ...interState,
        sortPage: payload,
      };

    case types.SET_COMP_CHART_TYPE:
      return {
        ...interState,
        compChartType: payload,
      };

    default:
      return interState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options.js